import { RadioButtonGroup } from "@repo/skapa";
import { t } from "@repo/translation";

import { dateOptions } from "./utils";

export const PresetRadioGroup = ({
  selectedOption,
  setSelectedOption,
}: any) => {
  const radioOptions = dateOptions.map((option) => ({
    key: option.id,
    id: option.id,
    label: t(`label.${option.id}`),
    name: "quick-date-selector",
    value: option.id,
    checked: option.id === selectedOption.id,
    onChange: () => {
      if (option.id === "custom_range") {
        setSelectedOption({
          ...selectedOption,
          ...option,
          startTime: selectedOption.startTime ?? option.startTime,
          endTime: selectedOption.endTime ?? option.endTime,
        });
      } else {
        setSelectedOption(option);
      }
    },
  }));

  return <RadioButtonGroup subtle list={radioOptions} />;
};
